import React from 'react';
import {Form, Input, Button, message,Modal} from 'antd';
import {FormattedMessage,injectIntl} from 'react-intl';
import actions from "../../store/actions"
import {connect} from 'react-redux';
const FormItem = Form.Item;
class RegistrationForm extends React.Component {
    state = {
        totalPeople: 0,
        historyDate: {},
    };
    /*上一步*/
    handleBack = (e) => {
        e.preventDefault();
        let info={
            cleanVis:false,
        }
        this.props.Clean(info);
        this.props.history.push("/Group");
    };
    /*四个input框*/
    totalPeo = () => {
        const {form} = this.props;
        let values = form.getFieldsValue();
        let totalA, totalB, totalC, totalD;
        if (values.UnderTwelve === undefined) {
            totalA = 0
        } else {
            totalA = Number(values.UnderTwelve)
        }
        if (values.ThirteenToEighteen === undefined) {
            totalB = 0
        } else {
            totalB = Number(values.ThirteenToEighteen)
        }
        if (values["CollegeStudents"] === undefined) {
            totalC = 0
        } else {
            totalC = Number(values["CollegeStudents"])
        }
        if (values["Adults"] === undefined) {
            totalD = 0
        } else {
            totalD = Number(values["Adults"])
        }
        let totalPeople = (totalA + totalB + totalC + totalD);
        this.setState({
            totalPeople: totalPeople
        });
        return totalPeople
    };

    /*下一步*/
    handleSubmit = (e) => {
        e.preventDefault();
        const {form} = this.props;
        let values = form.getFieldsValue();
        let totalPeople = (Number(values["UnderTwelve"]) + Number(values["ThirteenToEighteen"]) + Number(values["Adults"]));
        if (totalPeople > 30||totalPeople===0) {
            Modal.info({
                title: this.props.local==='zh'?"通知":'Notice',
                content: this.props.local==='zh'?'为保证最佳的参观体验，每次参观人数需控制在 30人以内，请修改参观人数后再提交信息，敬请谅解。':'Group tours are capped at 30 people to ensure tour quality. Please change the number of visitors to 30 or less, then try again.',
                onOk: function() {}
              });
           // message.warning(this.props.local==='zh'?'为保证最佳的参观体验，每次参观人数需控制在1-30人以内，请修改参观人数后再提交信息，敬请谅解。':'In order to ensure the best experience, the number of visitors must be within 1-30. Please modify the number of visitors before submitting information. Please understand.');
        } else {
            this.props.form.validateFieldsAndScroll((err, values) => {
                let info = {
                    ...values, totalPeople: this.state.totalPeople
                }
                if (!err) {
                    this.props.addValue2(info);
                    window.scrollTo(300, 350);
                    this.props.history.push("/Activities3");
                    console.log('Received values of form: ', values);
                }
            });
        }
    };
    formatMessage(id){
        return this.props.intl.formatMessage({id:id});
 
    }

    componentWillMount() {
        /*临时存储*/
        console.log('activities2',this.props);
        if(!this.props.Activities1||!this.props.Activities1.value){
            this.props.history.push('/Group');
            return;
        }
        let cleanValue =this.props.cleanValue;
        if( cleanValue.cleanVis === true){
            this.setState({
                historyDate:{}
            })
        }else{
            const {value} = this.props;
            if (value.totalPeople !== undefined) {
                this.setState({
                    totalPeople: value.totalPeople
                })
            }
            let history = this.props.value;
            if (history !== undefined || history !== '') {
                this.setState({
                    historyDate: {
                        UnderTwelve: history.UnderTwelve,
                        ThirteenToEighteen: history.ThirteenToEighteen,
                        CollegeStudents: history.CollegeStudents,
                        Adults: history.Adults,
                        Industry: history.Industry,
                        language: history.language,
                        VisitPurpose: history.VisitPurpose,
                    }
                })

            }
        }

    }

    render() {
        /*临时储存*/
        const {historyDate} = this.state;
        const {getFieldDecorator} = this.props.form;
        /*样式*/
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 8},
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 16},
            },
        };
        return <Form onSubmit={this.handleSubmit}>
            {/*12岁以下*/}
            <FormItem
                {...formItemLayout}
                label={<FormattedMessage
                    id="intl-Activities2-Under"
                />}

            >
                {getFieldDecorator("UnderTwelve", {
                    initialValue: historyDate && historyDate.UnderTwelve,
                    rules: [{ pattern: /^[0-9]*$/, message: this.formatMessage('intl-peopleNumber') },
                    {
                        
                        required: true, message: this.formatMessage('intl-inputNumer'),
                    }],
                })(
                    <Input style={{width: "300px"}} onBlur={this.totalPeo} type="number" min="0"
                           placeholder={this.formatMessage('intl-inputNumer')}
                    />
                )}
            </FormItem>
            {/*13岁到18*/}
            <FormItem
                {...formItemLayout}
                help=""
                label={<FormattedMessage
                    id="intl-Activities2-Eighteen"
                />
                }

            >
                {getFieldDecorator('ThirteenToEighteen', {
                    initialValue: historyDate && historyDate.ThirteenToEighteen,
                    rules: [{ pattern: /^[0-9]*$/, message: this.formatMessage('intl-peopleNumber') },
                    {patten: /^\+?[1|2]\d*$/, message: 'Please input your number!', required: true,},
                        {validator: "this.validateToNextPassword"}
                    ],
                })(
                    <Input placeholder={this.formatMessage('intl-inputNumer')} min="0"  onBlur={this.totalPeo} style={{width: "300px"}}
                           type="number"
                    />
                )}
            </FormItem>
            {/*大学生*/}
            {/* <FormItem
                {...formItemLayout}
                label={<FormattedMessage
                    id="intl-Activities2-Students"
                />}
                help="">
                {getFieldDecorator('CollegeStudents', {
                    initialValue: historyDate && historyDate.CollegeStudents,
                    rules: [{
                        required: true, message: 'Please input your number!'
                    }, {
                        whitespace: true,
                    }, {
                        validator: this.compareToFirstPassword,
                    }],
                })(
                    <Input placeholder="Please input the number" min="0" onBlur={this.totalPeo} style={{width: "300px"}}
                           type="number"
                    />
                )}
            </FormItem> */}
            {/*成年人*/}
            <FormItem
                {...formItemLayout}
                help=""
                label={<FormattedMessage
                    id="intl-Activities2-Adults"
                />}
            >
                {getFieldDecorator('Adults', {
                    initialValue: historyDate && historyDate.Adults,
                    rules: [{ pattern: /^[0-9]*$/, message: this.formatMessage('intl-peopleNumber') },{
                        required: true, message: 'Please input your number!'
                    }, {
                        validator: this.compareToFirstPassword,
                    }],
                })(
                    <Input  placeholder={this.formatMessage('intl-inputNumer')} onBlur={this.totalPeo} style={{width: "300px"}} min="0"
                           type="number"
                    />
                )}
            </FormItem>
            <div className="ant-row ant-form-item">
                <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-8">
                    <FormattedMessage id="intl-Activities2-Total number of visitors "/> ：
                </div>
                <div class="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-16" style={{lineHeight: "36px"}}>
                    <span style={{color: "red", padding: "0 10px"}}>{this.state.totalPeople}</span> 
                    <FormattedMessage id="intl-Activities2-People"/> 
                </div>
            </div>
            <FormItem style={{textAlign: "center"}}>
                <Button
                    style={{textAlign: "left", marginRight: "30px"}} onClick={this.handleBack}>
                    <FormattedMessage
                        id="intl-Activities-Previous"
                    />
                </Button>
                <Button type="primary" htmlType="submit"
                       className="btn-color-vi2"
                        style={{textAlign: "right"}}>
                    <FormattedMessage
                        id="intl-Activities-Next"
                    />
                </Button>
            </FormItem>
        </Form>
    }
}

const WrappedRegistrationForm = Form.create()(RegistrationForm);

class Activities2 extends React.Component {
    render() {
        return (<div className="insideDiv">
                <div className="center">
                    <ul className="timeLine">
                        <li className="active">
                            <i>1</i>
                            <p><FormattedMessage
                                id="intl-Activities-NumberOfVisitors"
                            /></p>
                        </li>
                        <li className="active">
                            <i>2</i>
                            <p>
                                <FormattedMessage
                                    id="intl-Activities-NumberOfVisitors2"
                                /></p>
                        </li>
                        <li>
                            <i>3</i>
                            <p><FormattedMessage
                                id="intl-Activities-Datails"
                            /></p>
                        </li>
                        <li>
                            <i>4</i>
                            <p><FormattedMessage
                                id="intl-Activities-Confirmation"
                            /></p>
                        </li>
                    </ul>
                    <dl className="applyDl">
                        <dt><FormattedMessage
                            id="intl-Activities2-Please"
                        /></dt>
                        <dd><FormattedMessage
                            id="intl-Activities2-Guided"
                            /></dd>
                    </dl>
                    <h4 className="applyTitle"><FormattedMessage
                        id="intl-Activities2-Number"
                    /></h4>
                    <WrappedRegistrationForm {...this.props}/>
                </div>
            </div>
        )
    }
}

export default connect(state => ({...state,...state.Activities2, ...state.Language,...state.Home}), {...actions,...actions.Activities2, ...actions.Language,...actions.Home})(injectIntl(Activities2))




// WEBPACK FOOTER //
// ./src/containers/Activities/Activities2.js